import React from 'react';
import styles from './DataQualityScore.module.css';

function ProgressBar({ value }) {
    return (
        <div className={styles.bar}>
            <div className={styles.fill} style={{ width: `${Math.min(value, 100)}%` }} />
        </div>
    );
}

export default function DataQualityScore({ data }) {
    const score = data.quality_score;
    const scoreClass = score >= 80 ? styles.good : score >= 50 ? styles.medium : styles.poor;

    const metrics = [
        { label: 'إدخالات كاملة',      ...data.complete_entries },
        { label: 'مع صورة',            ...data.with_photos },
        { label: 'مع تصنيف',          ...data.with_category },
        { label: 'مع تصنيف فرعي',     ...data.with_subcategory },
    ];

    return (
        <div className={styles.wrapper}>
            <div className={`${styles.scoreCard} ${scoreClass}`}>
                <p className={styles.scoreLabel}>درجة الجودة</p>
                <p className={styles.score}>{score}%</p>
                <p className={styles.total}>{data.total_entries} إدخال</p>
            </div>

            <div className={styles.metrics}>
                {metrics.map((m, idx) => (
                    <div key={idx} className={styles.metric}>
                        <div className={styles.metricHeader}>
                            <span>{m.label}</span>
                            <span className={styles.metricCount}>{m.count}</span>
                        </div>
                        <ProgressBar value={m.percentage} />
                        <span className={styles.metricPct}>{m.percentage}%</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
